export default __webpack_public_path__ + "static/media/storageUnit1-afterD-1920w.fa9a08b6.png";